/* @flow */
import * as React from 'react';
import invariant from 'invariant';
import cx from 'classnames';

import Table from 'components/Table.jsx';
import TableRow from 'components/TableRow.jsx';
import Text from 'components/Text.jsx';

import './styles/ComposableTable.scss';

type Props = {
  columnHeaders: string[], // TODO: replace with smart headers of some sort (for sorting)
  columnGenerators: Function[],
  rows: Object[],
  keyField: string,
  rightAlignedLastColumn?: boolean,
};

export default function ComposableTable({
  columnHeaders,
  columnGenerators,
  rows,
  keyField,
  rightAlignedLastColumn,
}: Props) {
  invariant(
    columnGenerators.length === columnHeaders.length,
    "Won't have the same number of headers as columns!"
  );
  const headers = columnHeaders.map(header => (
    <th key={header}>
      <Text data-test="column-header">{header}</Text>
    </th>
  ));

  const buildRow = (row: Object) => {
    return columnGenerators.map((generator, index) => {
      const key = index;
      return <td key={key}>{generator(row)}</td>;
    });
  };

  return (
    <Table
      className={cx(
        'ComposableTable',
        rightAlignedLastColumn && 'ComposableTable--rightAlignedLastColumn'
      )}
      head={<tr>{headers}</tr>}>
      <tbody>
        {rows.map(row => {
          return (
            <TableRow
              hoverable={Boolean(row.onRowClick)}
              onClick={() => {
                if (row.onRowClick) {
                  row.onRowClick();
                }
              }}
              key={row[keyField]}>
              {buildRow(row)}
            </TableRow>
          );
        })}
      </tbody>
    </Table>
  );
}
